import React from 'react';
import { T } from '../../../traks';

const QandAs = [
	{
		q: <T>How do I submit a entry?</T>,
		a:
		<T>
			Anyone who has access to the link below can submit an entry. You can change this link under company settings
			if you are an admin. Distribute it to those who are supposed to be able to submit cases.
		</T>
	},
	{
		q: <T>Who has access to the entries?</T>,
		a:
		<T>
			Only the caseworker assigned to the entry has access to content of the entry. This is in order to protect the wistleblower, and 
			to make sure, that access is limited to as few people as possible
		</T>
	},
	{
		q: <T>How do I communicate with the entry creator?</T>,
		a:
		<T>
			The assigned caseworker is able to send messages to the case reporteer. If the case reporter is not anonymous, 
			the case reporter is notified, otherwise the case reporter must actively check for activity on their case.
		</T>
	},
	{
		q: <T>Who will be assigned to the case once submitted?</T>,
		a:
		<T>
			When someone creates a case, they must also choose who to assign the case to. A list will be presented with 
			the different options for who will be assigned to the case. Whether a user is an option for the case creator
			can be set under each user.
		</T>
	},
	{
		q: <T>What is the difference on an internal user and a external user?</T>,
		a:
		<T>
			The internal user(s) will most often be someone inside your own company. These will often be the 
			caseworkers who will manage the cases and make sure they will be handled, following the laws.
			External users are, on the other hand, 3rd party agents, who can assist in cases where the
			circumstances requires it.
		</T>
	},
	{
		q: <T>Can I give temporary access to an entry to someone outside the system?</T>,
		a:
		<T>
			Yes, An admin or the assigned caseworker can share the entry temporarily through creating a link, that will
			expire after some time. The reciever of the link must be two-factor authenticated upon accessing it.
		</T>
	}
];

export default QandAs;

